{
  "account": {
    "title": "Hesabım",
    "list": {
      "title": "Hesaplar",
      "description": "Bağlı hesap faturaları listesi"
    },
    "form": {
      "name": {
        "title": "Ad",
        "description": "Hesabınızın adı"
      },
      "password": {
        "title": "Şifre",
        "description": "Hesabınız için yeni bir şifre belirleyin; mevcut şifreyi korumak için boş bırakın"
      },
      "emailPreferences": {
        "title": "E-posta tercihleri",
        "description": "E-posta bildirim türlerini seçin"
      }
    },
    "billing": "Fatura detayları",
    "subscriptions": "Abonelikler",
    "manageSubscription": "Aboneliği yönet",
    "popup": {
      "cancel": "Aboneliğinizi iptal etmek istediğinizden emin misiniz?<br/>Web siteniz çeviri işlemi, mevcut abonelik sürenizin sonuna kadar devam edecektir. Bundan sonra çeviri devre dışı bırakılacaktır.<br/>Lütfen kullanılmayan süre için iade hakkı kazanamayacağınızı unutmayın.",
      "downgrade": "Düşürmek istediğinizden emin misiniz? Değişiklik hemen yürürlüğe girecektir.<br/>Lütfen mevcut fatura döngüsünün kalan süresi için iade hakkı kazanamayacağınızı unutmayın.<br/>Yeni plan ücreti bir sonraki fatura döngüsünde uygulanacaktır.",
      "default": "Planınızı değiştirmek istediğinizden emin misiniz?",
      "resume": "Aboneliğinizi yeniden başlatmak istediğinizden emin misiniz?"
    }
  },
  "ai_translation": {
    "header": "Yapay Zeka Çevirisi",
    "plan": {
      "header": "Yapay Zeka Çevirisi Fiyatlandırması",
      "used": "Yapay Zeka bakiyenizde {words_used} / {words_allowed} çevrilmiş kelime kullandınız.",
      "remaining": "Mevcut yapay zeka bakiyesi:",
      "words": "kelime",
      "add_more_credits": "Daha fazla yapay zeka bakiyesi ekle",
      "details": {
        "idiomatic_expressions": "İdyomatik ve teknik ifadeler",
        "background_translation": "Arka planda çeviri",
        "best_website": "Mükemmel çeviri kalitesi gerektiren web siteleri",
        "page_context": "Sayfa ve web sitesi bağlamında çeviri",
        "perfect_quality": "Mükemmel kalite, uygun fiyat",
        "no_recurring": "Yinelenen ödeme yok, ön ödemeli kota",
        "save_40": "20$’lık plana göre %40 tasarruf",
        "save_50": "20$’lık plana göre %50 tasarruf"
      },
      "quota": "{estimated_words} kelime ~ {estimated_pages} sayfa"
    },
    "settings": {
      "banner": {
        "title": "Linguise Yapay Zeka Çevirisi",
        "intro": "Linguise, çeviri görevleri için optimize edilmiş en yeni Llama yapay zekâ modellerini kullanan yeni premium özelliği Linguise AI Çevirisi’ni tanıtmaktan heyecan duyuyor. Sayfanın ve tüm web sitesinin bağlamını dikkate alarak kusursuz sonuçlar sunar. Müşterilerinize her dilde mükemmel biçimde yankı uyandıran çeviri kalitesinin zirvesini sunun.",
        "button": "Şimdi yükselt"
      },
      "alert": {
        "description": "Bu özellik mevcut planınızda yer almamakta ve ayrı satın alınması gerekmektedir.\nTüm aşağıdaki seçeneklerin kilidini açmak için bu eklentiyi etkinleştirin."
      },
      "languages": {
        "title": "Diller için yapay zeka çevirisini uygula",
        "description": "Yapay zeka çevirisinin uygulanmasını istediğiniz belirli dili seçin"
      },
      "button": {
        "save": "Ayarları kaydet"
      },
      "form": {
        "advanced": {
          "title": "Gelişmiş yapay zeka talimatları",
          "description": "Gelişmiş yapay zeka talimatları"
        },
        "enable_mode": {
          "title": "YAPAY ZEKA ÇEVİRİSİNİ AÇ",
          "description": "Yapay zeka çevirisinin nasıl etkinleştirileceğini seçin.\nYalnızca kurallar, aşağıdaki kuralları uygulayacaktır.\nYalnızca canlı düzenleyici, çeviri sayfasını canlı düzenleyici görünümünden sayfa sayfa etkinleştirmeye izin verecektir.\nKurallar ve canlı düzenleyici, her iki özelliği de kullanacaktır.",
          "disabled": "Devre dışı",
          "rules": "Yalnızca kurallar",
          "live_editor": "Yalnızca canlı düzenleyici",
          "all": "Kurallar ve canlı düzenleyici"
        },
        "rule_application": {
          "description": "Yapay zeka çevirisini statik içeriğe, dinamik içeriğe ya da her ikisine birden uygula",
          "title": "İçeriğe uygula",
          "all": "Tüm içerik",
          "static": "Statik içerik",
          "dynamic": "Dinamik içerik"
        },
        "website_topic": {
          "title": "Web sitesi konusu",
          "placeholder": "Sushi restoranı...",
          "description": "Daha kaliteli çeviri için web sitenizin konusunu tanımlayın (ör. Hukuk, sushi restoranı, bisiklet parçaları e-ticaret sitesi…)\nWeb sitesi konusunu lütfen İngilizce girin."
        },
        "apply_to_urls": {
          "title": "URL'lere uygula",
          "description": "Yapay zeka çevirisinin uygulanmasını istediğiniz belirli URL'leri seçin",
          "all_urls": "Tüm URL'ler",
          "selected_urls": "Seçili URL'ler",
          "label": "Uygulanacak URL",
          "placeholder": "Uygulanacak URL",
          "wildcard": "Joker karakter",
          "regex": "Düzenli ifade",
          "add": "Yeni ekle",
          "expression": "İfade türü"
        },
        "apply_languages": {
          "title": "Dillere uygula",
          "description": "Yapay zeka çevirisinin uygulanmasını istediğiniz belirli dili seçin",
          "all_languages": "Tüm diller",
          "selected_languages": "Seçili diller",
          "placeholder": "Dil seçin...",
          "feedback": "Bir dil seçmelisiniz"
        },
        "formality": {
          "title": "Resmiyet",
          "description": "Çevirilerdeki resmiyet derecesini belirleyin; bazı izleyici ve bağlamlar için önemli olabilir.\n\"Nötr\" orijinal içeriğin resmiyetini korumaya çalışır.\n\"Resmi\" profesyonel, iş veya hukuki içerik içindir (örneğin, İspanyolca'da \"usted\" gibi resmi zamirler kullanılır).\n\"Gayriresmi\" rahat, günlük içerik içindir (örneğin, İspanyolca'da \"tú\" kullanılır).",
          "neutral": "Nötr",
          "formal": "Resmi",
          "informal": "Gayriresmi"
        },
        "sentence_structure": {
          "classic": "Klasik",
          "short": "Kısa ve vurucu cümleler",
          "detailed": "Detaylı ve açıklayıcı cümleler",
          "title": "Cümle yapısı",
          "description": "Yazım stili tercihini tanımlayın."
        },
        "content_purpose": {
          "marketing": "Pazarlama/tanıtım (ikna edici, etkileyici üslup)",
          "technical": "Teknik/talimat (açık, net, eylem odaklı)",
          "support": "Müşteri desteği (empatik, yardımsever, güven verici)",
          "legal": "Hukuk/uygunluk (kesin, resmi, çift anlamlı olmayan)",
          "educational": "Eğitimsel (açık, yapılandırılmış, erişilebilir)",
          "other": "Diğer (İngilizce olarak)",
          "title": "İçerik amacı",
          "description": "Çevrilen içeriğin işlevsel amacını tanımlayın.",
          "other_placeholder": "Amacı açıklayın..."
        },
        "target_audience": {
          "title": "Hedef kitle",
          "description": "Çevrilen içeriğin yöneldiği hedef kitle tanımı (İngilizce olarak).",
          "placeholder": "Örneğin, İspanyolca konuşan ebeveynler, AB gizlilik yetkilileri"
        },
        "override_default_translations": {
          "title": "Varsayılan çeviriyi geçersiz kıl",
          "description": "Evet olarak ayarlanırsa, bu seçenek içeriğin zaten Bulut Yapay Zekâ çevirisiyle (varsayılan çeviri modeli) çevrilmiş olsa bile AI (Linguise AI) ile çevrilmesini zorlar."
        },
        "force_replace_before": {
          "title": "AI ile yeniden çeviriyi zorla",
          "description": "AI çevirisi seçilen tarihten önce yapılmış tüm içerikleri AI ile yeniden çevirin; örneğin eski bir modelle çevrilen içerikleri. Yeniden çeviri, kurallara tabi sayfalar bir sonraki ziyaret edildiğinde yapılır ve AI kredilerinizi kullanır.",
          "before_date": "Bir tarihten önce"
        },
        "model": {
          "current": "Mevcut",
          "title": "Model",
          "description": "Kullanmak istediğiniz LLM çeviri modelini seçin",
          "load_error": "Mevcut modeller yüklenemiyor. Lütfen daha sonra tekrar deneyin.",
          "thinking_warning": "Bu model yüksek düzeyde akıl yürütme (\"düşünme\") kullanır ve çeviri başına önemli ölçüde daha fazla token tüketir."
        },
        "override_manual_and_selected": {
          "no_default": "Hayır (varsayılan)",
          "title": "Manuel ve seçili çevirilerin üzerine yaz",
          "description": "Varsayılan olarak, elle düzenlediğiniz bir çeviri, yapay zeka ile geliştirilmiş çeviri oluşturulduktan sonra bile sitenizde kalır. Bunun yerine yapay zeka ile geliştirilmiş çeviriyi göstermek için Evet'i seçin. Manuel çevirileriniz saklanır ve istediğiniz zaman geri dönebilirsiniz. Bu, yeni çeviriler almak için sayfaları yeniden çevirdiğinizde de geçerlidir; en yeni çeviri otomatik olarak kullanılır."
        }
      },
      "message": {
        "save_success": "Mevcut çevrilmiş içerikten yaklaşık {{ai_affected_urls}} sayfa yapay zekâ çevirisiyle geliştirilecektir.",
        "save_success_only": "Ayarlar başarıyla kaydedildi."
      }
    },
    "pricing": {
      "plan": {
        "title": "Yapay zeka çeviri kotası sipariş et",
        "buy_button": "YAPAY ZEKA ÇEVİRİ PAKETİNİ SATIN AL"
      },
      "modal": {
        "title": "Plan değişikliğini onayla",
        "description": "Yapay Zeka Çeviri planınızı değiştirmek istediğinizden emin misiniz?",
        "button_cancel": "İptal",
        "button_confirm": "Onayla",
        "loading": "Lütfen bekleyin...",
        "amount": "Tutar",
        "credit": "Kredi",
        "total_due": "Toplam tutar"
      },
      "comparison": {
        "title": "Google Cloud AI çeviri\nvs Linguise AI çeviri",
        "list": {
          "0": {
            "google": "Hızlı ve güvenilir çeviriler",
            "linguise": "Deyimsel ve teknik ifadeleri işle"
          },
          "1": {
            "google": "Tüm web sitesi sayfalarının anında çevirisi",
            "linguise": "Çevirilerin arka planda oluşturulması"
          },
          "2": {
            "google": "En iyi kalite, düşük fiyat",
            "linguise": "Mükemmel kalite, uygun fiyat"
          },
          "3": {
            "google": "Büyük web siteleri veya düşük bütçe için en uygunu",
            "linguise": "Mükemmel çeviri kalitesi gerektiren web siteleri için en iyisi"
          },
          "4": {
            "google": "Çeviri için sayfa bağlamı",
            "linguise": "Çeviri için sayfa ve web sitesi bağlamı"
          }
        }
      },
      "botom_banner": {
        "title": "Yeni Linguise AI Çeviri ile",
        "sub_title": "Eşsiz Çeviri Doğruluğunu Deneyimleyin",
        "description": "Linguise, köşe bucak çeviri LLM (çağrı üstü en yeni Llama modelleri) kullanan güçlü yeni bir seçenek Linguise AI Çeviri hizmetini sunarak kendiliğinden çeviri hizmetlerini geliştiriyor. Bu eklem, web geliştiricilerine ve ajanslara mükemmelliğin zorunlu olduğu projeler için daha üst düzeyde çeviri kalitesi sağlar. Linguise AI Çeviri, zaten kaliteli olan Google Cloud AI çevrimizle tamamlanarak size daha fazla esneklik ve hassasiyet sunar."
      }
    },
    "success": {
      "tab_title": "AI Çeviri planı satın aldığınız için teşekkürler!",
      "title": "AI Çeviri planı satın aldığınız için teşekkürler!",
      "subtitle": "AI Çeviri planınız başarıyla satın alındı!",
      "message": "AI Çeviri planınızı AI Çevirileri ayarlar sayfasında yönetebilirsiniz.",
      "home": "AI Çevirisini Yönet"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Ad",
        "description": "Fatura hesabı adı"
      },
      "phone": {
        "title": "Telefon",
        "description": "Fatura hesabı telefonu"
      },
      "email": {
        "title": "E-posta",
        "description": "Fatura hesabı e-postası"
      },
      "address": {
        "title": "Adres",
        "description": "Fatura hesabı adresi",
        "city": "Şehir",
        "country": "Ülke",
        "address1": "Adres 1",
        "address2": "Adres 2",
        "postal": "Posta kodu",
        "state": "Eyalet"
      },
      "tax": {
        "title": "Vergi numarası"
      }
    }
  },
  "checkouts": {
    "header": "Ödeme",
    "payment_method": "Ödeme Yöntemi Seçin",
    "stripe_card": "Kredi kartı (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Yeni fatura adresi girin",
      "existing": "Mevcut adresi kullan"
    },
    "pay_stripe": "Onayla ve öde",
    "terms": "Aboneliğinizi onaylayarak, Linguise'nin gelecekteki ödemeler için şartlarımıza uygun olarak sizden ücret almasına izin vermiş olursunuz. Aboneliğinizi dilediğiniz zaman iptal edebilirsiniz.",
    "coupon": {
      "title": "Kuponunuz var mı?",
      "placeholder": "Kupon kodunuzu buraya girin",
      "apply": "Uygula",
      "percent": "%{{0}} indirim"
    },
    "add_new": "Yeni ekle",
    "use_existing": "Mevcut ödeme yöntemini kullan",
    "recurring": {
      "month_single": "Aylık faturalandırılır",
      "month_many": "Her {{count}} ayda bir faturalandırılır",
      "year_single": "Yıllık faturalandırılır",
      "year_many": "Her {{count}} yılda bir faturalandırılır",
      "day_single": "Günlük faturalandırılır",
      "day_many": "Her {{count}} günde bir faturalandırılır",
      "week_single": "Haftalık faturalandırılır",
      "week_many": "Her {{count}} haftada bir faturalandırılır"
    },
    "add_new_no_stripe": "Yeni kart ekle",
    "summary": {
      "title": "Özet",
      "subtotal": "Ara toplam",
      "total": "Toplam"
    }
  },
  "dashboard": {
    "main": {
      "title": "Panoya"
    },
    "statistics": {
      "main_title": "Son 30 günün istatistikleri",
      "characters": "Çevrilen karakterler",
      "words": "Çevrilen kelimeler",
      "bandwidth": "Gelen bant genişliği",
      "request": "İstekler",
      "page_views": "Dile göre sayfa görüntülemeleri (son 30 gün)",
      "multilingual_views": "Çok dilli sayfa görüntülemeleri (son 30 gün)",
      "most_page_viewed": "En çok görüntülenen 20 sayfa (son 30 gün)",
      "no_data_yet": "Henüz veri yok",
      "th_language": "Dil",
      "th_page_views": "Sayfa görüntülemeleri",
      "real_visitors": "Gerçek ziyaretçiler",
      "crawler": "Web tarayıcısı"
    },
    "planHints": {
      "subscribeButton": "Abone ol",
      "upgradeButton": "Yükseltme yapın",
      "usedWords": "Şu anda {words_used} kelime kullanıyorsunuz",
      "noPlan": "Bu alan adı için etkin plan yok. Bir plana abone olun ve web sitenizi çevirmeye başlayın",
      "noPlanShopify": "Bu alan adı için etkin plan yok. Shopify panelinizden bir plana abone olun ve web sitenizi çevirmeye başlayın",
      "trialUsage": "Deneme planında yer alan {words_allowed} kelimeden {words_used} tanesini kullanıyorsunuz.",
      "trialEnds": "1 aylık deneme süresi {trial_ends} tarihine kadar aktiftir.",
      "subscribeMessage": "Web sitenizin çevrili kalması için bitmeden abone olun",
      "subscribeMessageShopify": "Web sitenizin çevrili kalması için bitmeden Shopify panelinizden abone olun",
      "trialReachedLimit": "Deneme süresi için maksimum çevrilmiş kelimeye ulaştınız.\nWeb sitenizi çevirmeyi sürdürmek için planlarımızdan birine abone olun.",
      "paidUsage": "Planınızda {words_allowed} / {words_used} çevrilmiş kelime kullandınız.",
      "paidReachedLimit": "Mevcut plan için maksimum çevrilmiş kelimeye ulaştınız.\nWeb sitenizin içeriğini çevirmeye devam etmek için planınızı yükseltin.",
      "trialOfferedUsage": "Deneme planında yer alan {words_allowed} kelimeden {words_used} tanesini kullanıyorsunuz.(İçinde {free_words} ücretsiz kelime bulunuyor)",
      "paidOfferedUsage": "Planınızda {words_allowed} / {words_used} çevrilmiş kelime kullandınız.(İçinde {free_words} ücretsiz kelime bulunuyor)",
      "noPlanExtra": "Lütfen etkin olmayan alan adlarının ve verilerinin düzenli olarak silindiğini unutmayın.",
      "planRecommended": "Mevcut çeviri hacminize göre tavsiye edilen plan:",
      "planMaximumWords": "{{words}} kelime",
      "notHaveTranslatedWords": "Henüz çeviri yapmadınız"
    },
    "translationSetup": {
      "kicker": "ALT ALAN ADI KURULUMU",
      "title": "Çeviri kurulumunu kontrol et",
      "description": "DNS’yi, çevrilen ana bilgisayarları, kaynak siteye erişimi ve hesap sınırlarını inceleyin.",
      "starting": "Kontrol ediliyor...",
      "button": "Kurulumu kontrol et",
      "viewLatest": "Son sonucu görüntüle",
      "viewCurrent": "Geçerli kontrolü görüntüle",
      "runAgain": "Kontrolü yeniden çalıştır",
      "viewDetails": "Ayrıntıları görüntüle",
      "hideDetails": "Ayrıntıları gizle",
      "error": "Kurulum kontrol edilemiyor",
      "allPassed": "Tüm kontroller başarılı",
      "setupNeedsAttention": "Kurulumun incelenmesi gerekiyor",
      "setupNeedsAttentionDescription": "Bir veya daha fazla kontrol başarısız oldu. Aşağıdaki maddeleri inceleyin veya Linguise desteğiyle iletişime geçin.",
      "lastChecked": "Son kontrol {{time}}",
      "domainOwnership": "Alan adı sahipliği",
      "domainOwnershipDescription": "Doğrulama kaydı bulundu",
      "domainOwnershipFailure": "Sahiplik DNS kaydı doğrulanamadı.",
      "translatedHosts": "Çevrilen ana bilgisayarlar",
      "translatedHostsDescription": "{{count}} dil ana bilgisayarı kontrol edildi",
      "translatedHostsFailure": "Bir veya daha fazla dil CNAME kaydı hatalı.",
      "subdomainPage": "Alt alan adı sayfası",
      "subdomainPageDescription": "{{count}} çevrilmiş sayfa HTTPS kabul ediyor",
      "subdomainPageFailure": "Bir veya daha fazla çevrilmiş sayfa açılırken TLS bağlantısı başarısız oldu.",
      "originalSite": "Kaynak site",
      "originalSiteDescription": "Kaynak sitenin DNS, TLS ve yanıt kontrolleri",
      "originalSiteFailure": "Kaynak sitenin DNS, TLS veya yanıt kontrolü başarısız oldu.",
      "documentationAdvice": {
        "dns": "DNS kurulumunu incele",
        "tls": "HTTPS kurulumunu incele",
        "origin": "Kaynak site kurulumunu incele",
        "diagnostic": "Sorun giderme adımlarını incele"
      },
      "evidence": {
        "originDns": "Kaynak DNS",
        "originTls": "Kaynak TLS",
        "originHttp": "Kaynak yanıtı",
        "observedTargets": "Gözlemlenen hedefler",
        "recordCount": "Bulunan kayıtlar",
        "addressCount": "Bulunan adresler",
        "statusCode": "HTTP durumu",
        "redirect": "Yönlendirme",
        "expiresAt": "Sertifikanın süresi doluyor",
        "raw": "{{key}}",
        "noValue": "Değer yok"
      },
      "checkerError": "Bazı kontroller tamamlanamadı.",
      "coreLocation": "{{location}} konumundan kontrol edildi",
      "status": {
        "queued": "Kuyrukta",
        "running": "Çalışıyor",
        "completed": "Tamamlandı",
        "failed": "Başarısız",
        "passed": "Başarılı",
        "warning": "Uyarı",
        "unknown": "Bilinmiyor",
        "skipped": "Atlandı",
        "not_applicable": "Uygulanamaz"
      }
    },
    "throttling": {
      "title": "Çeviri sınırı",
      "description": "Geçici kullanım sınırları",
      "unavailable": "Geçici çeviri sınırları kullanılamıyor",
      "window": "{{used}} / {{max}} kelime",
      "resetsIn": "{{time}} içinde sıfırlanır",
      "throttled": "Çeviri geçici olarak duraklatıldı",
      "throttledDescription": "Geçici kullanım sınırına ulaşıldı. Bu dönem sıfırlandığında çeviri devam eder."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "{{step}} / {{total}}. ADIM",
      "doneLabel": "TAMAMLANDI, ÇEVİRMEYE BAŞLAYABİLİRSİNİZ!",
      "finish": {
        "title": "",
        "description": "Web sitenizde kullanılacak API anahtarı budur"
      },
      "instructions": "Kurulum talimatı",
      "domainSetting": "Alan adı ayarı",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP Betiği",
        "wizardWordpressStep1": "1. ",
        "wizardWordpressStep2": "\n 2. Eklenti ayarlarından API anahtarınızı kopyalayıp yapıştırın\n",
        "wizardWordpressStep3": "3. Çevirmeye hazırsınız\n\n",
        "wizardWordpressStep4": "Daha detaylı talimatlar için lütfen belgelerimize göz atın: ",
        "wizardJoomlaStep1": "1. Joomla paket bağlantısı: ",
        "wizardJoomlaStep2": "\n2. Eklenti yapılandırma ayarlarında API anahtarınızı kopyalayın ve doldurun",
        "wizardJoomlaStep3": "3. Modül yapılandırmasında görüntülemek istediğiniz dilleri ayarlayın ve modülünüzü ihtiyacınız olan yere ekleyin.",
        "wizardJoomlaStep4": "\n 4. Çevirmeye hazırsınız\n\n",
        "wizardPhpStep1": "1. Php betiğimizi indirin ve buraya ",
        "wizardPhpStep2": "\n2. Belgeler sayfamızdaki kurulum talimatlarını buradan takip edin ",
        "wizardPhpStep3": "\n3. Modülü sayfalarınıza ekleyin.",
        "wizardPhpStep4": "\n Aşağıdaki kodu kopyalayın ve html sayfanızın head bölümüne ekleyin, anahtar modülü otomatik olarak görüntüleyecektir\n",
        "dispatchStep1": "Gerekli verileri başarıyla Linguise eklentisine gönderdik, artık aşağıdaki pencereyi kapatabilirsiniz.",
        "dispatchStep2": "Bu pencereyi kapatırken belirteç eksik olması durumunda lütfen aşağıdaki belirteci kopyalayın:",
        "dispatchStep3": "Bayrak anahtarımızı otomatik olarak etkinleştirmek için bu snippet’i de kopyalayabilirsiniz",
        "wizardOtherStep1": "Linguise’i alan adınıza kurmak için aşağıdaki talimatları izleyin.\n",
        "wizardOtherStep2": "Aşağıdaki kodu kopyalayın ve html sayfanızın head bölümüne ekleyin, anahtar modülü otomatik olarak görüntüleyecektir.\n"
      },
      "trialAlreadyUsed": "Görünüşe göre ücretsiz denemenizi zaten kullandınız, bu nedenle çeviri kotası satın almanız gerekiyor\nLütfen bir plana abone olun veya denemenizi uzatmamız için bizimle iletişime geçin.",
      "usefulLinks": "Başlamak için faydalı bağlantılar",
      "linkDocumentation": "Belgelendirme",
      "linkExtensionDl": "Eklenti indirme",
      "linkSubscribe": "Hemen bir plana abone olun",
      "linkDashboard": "Panele git",
      "exclusion": {
        "title": "Şirket ve ürün adları",
        "description": ""
      },
      "finishButton": "Kurulumu bitir",
      "subdomains": "Alt alan adları",
      "subdomain_setup": "Alan adı kurulumu",
      "subdomain_auto_setup": "DNS’nizi otomatik olarak bağlayın",
      "subdomain_manual_setup": "DNS girişlerini kendim ekleyeceğim",
      "subdomain_skip": "Daha sonra yap",
      "auto_subdomains_info": "Site oluşturucu CMS’nizin dilleri alt alan başına ayarlamak için bir DNS yapılandırması gerekir (örn. es.domain.com).",
      "auto_subdomains_info_2": "Bunu Entri kullanarak otomatik olarak yapabilirsiniz. DNS yöneticinize bağlanmak ve onları Entri ile eklemek için \"DNS’nizi otomatik olarak bağlayın\" düğmesine tıklamanız yeterlidir.",
      "auto_subdomains_info_manual": "Veya \"DNS girişlerini kendim ekleyeceğim\" düğmesine tıklayarak alan adınızı manuel olarak yapılandırabilirsiniz.",
      "breadcrumbs": {
        "step1": "Adım 1: Alan Adı, İçerik Yönetim Sistemi ve Diller",
        "step2": "Adım 2: Dil DNS'si",
        "step3": "Adım {{step}}: Kurulum talimatları"
      }
    },
    "form": {
      "urls": {
        "dash": "Tire -",
        "underscore": "Alt çizgi _",
        "title": "URL’leri çevir",
        "description": "Tüm sayfalarda çevirmek ister misiniz",
        "char_description": "URL’lerde yetkisiz karakterlerin yerine kullanılacak karakter",
        "advertisement_title": "⚠ Çok sayıda dil belirlediniz.\n",
        "advertisement": "Genellikle web sitelerinin çevirisine ilk başta birkaç dil ile başlamanızı öneririz. Web sitenizin yaklaşık kaç kelime olduğu hakkında bir fikir edinirsiniz. Aynı zamanda SEO açısından da daha iyidir, çünkü Google botları sayfa sayısı az olduğunda tüm sayfalarınızı daha hızlı tarar. Bir hafta sonra birkaç dil daha ekleyebilirsiniz."
      },
      "url": {
        "title": "Url",
        "description": "Ana alan adı URL’nizi http:// veya https:// ile başlayarak girin",
        "placeholder": "Alan adı URL’si",
        "advertisement_http": {
          "title": "https protokolünü kullanmıyorsunuz",
          "description": "Lütfen alan adınızın aslında https protokolünü kullanmadığını kontrol edin, bu günümüzde önerilen durumdur."
        },
        "advertisement_www": {
          "title": "Alt alan adınız www değil",
          "description": "Çoğu zaman varsayılan alt alan adı www’dir (örn. https://www.mydomain.com). Bu sizin durumunuzda geçerli olmayabilir, lütfen eklemek istediğiniz alan adının doğru olduğundan emin olun."
        },
        "invalid_url": {
          "line1": "Alan adınızı bulamadık. Lütfen alan adınızın İnternet üzerinden herkese açık olarak erişilebilir olduğunu ve başka bir yere yönlendirilmediğini kontrol edin.",
          "line2": "Alan adınızın erişilebilir olduğundan eminseniz, alan adı doğrulamasını atlayabilir ve \"Sonraki adım\" düğmesine tekrar basabilirsiniz",
          "contact": "Her durumda bize şu adresten ulaşabilirsiniz:",
          "force": "Alan adı doğrulamasını atla"
        },
        "invalid_subdomain_url": "Bu URL'ye izin verilmiyor. Alt alan adları şu biçimde olmalıdır: https://www.domain.tld veya alt dizin olmadan https://domain.tld"
      },
      "account": {
        "title": "Hesap",
        "description": "Bu alan adını atamak için bir hesap seçin",
        "placeholder": "Hesap seçin...",
        "feedback": "Bir hesap seçmelisiniz"
      },
      "platform": {
        "title": "Platform",
        "description": "Web sitenizin CMS adına göre platformunu seçin",
        "learn": "Nasıl seçileceğini öğren",
        "placeholder": "CMS adına göre platform ara...",
        "info": {
          "title": "⚠ Bu platform yakın zamanda eklendi.\n",
          "desc": "Bu web sitesi oluşturucu platformu Linguise tarafından desteklenir, ancak yakın zamanda eklendi. Herhangi bir sorun yaşarsanız, lütfen doğrudan destek e-postasıyla bizimle iletişime geçin:"
        },
        "description_read_only": "Web sitenizin kullandığı platform",
        "feedback": "Bir platform seçmelisiniz"
      },
      "language": {
        "title": "Dil",
        "description": "Web sitenizin temel dilini seçin",
        "placeholder": "Dil seçin...",
        "feedback": "Bir dil seçmelisiniz",
        "description_read_only": "Web sitenizin temel dili"
      },
      "token": {
        "title": "API Anahtarı",
        "description": "Bu, web sitenize kopyalanacak API Anahtarıdır",
        "copy": "Panoya kopyala",
        "reset": "API Anahtarını sıfırla",
        "reset_confirm": "Lütfen API Anahtarı sıfırlamasını onaylayın"
      },
      "languages": {
        "title": "Çeviri dilleri",
        "description": "Web sitenizin hangi dillere çevrilebilir olmasını istediğinizi seçin",
        "placeholder": "Dilleri seçin...",
        "feedback": "Bir dil seçmelisiniz"
      },
      "defaultRules": {
        "title": "Varsayılan kurallar",
        "description": "Çevirileri geliştirmek ve WordPress kontrol paneli gibi istenmeyen içeriklerin çevrilmesini önlemek için bir dizi kullanılması gereken kural tanımladık.\nBu kuralları isterseniz daha sonra kaldırabilir veya düzenleyebilirsiniz."
      },
      "disallow_deletion": "Aktif aboneliği olan alan adı silinemez",
      "delete_confirm": "Lütfen alan adı silmeyi onaylayın",
      "delete": "Alan adını sil",
      "dynamic": {
        "title": "Dinamik İçeriği Çevir",
        "description": "JavaScript ve AJAX isteğiyle oluşturulan dinamik içerik çevrilecektir (Bu seçeniz çeviri kullanımlarınızı artıracaktır)"
      },
      "partial_translations": {
        "title": "Kısmi Çeviriye İzin Ver",
        "description": "Hesabınız çeviri kotasına ulaştıysa ama sayfa hâlâ çeviri gerektiriyorsa, Linguise zaten çevrilmiş olan içerikle sayfayı görüntülemeye devam edebilir.\nAncak sayfanın bazı bölümleri kota yükseltmenize kadar çevirisiz kalacaktır.\n\nAz miktarda çevirisiz içerik genellikle SEO’ya zarar vermezken, çok fazla çevirisiz içerik kullanıcı deneyimini olumsuz etkileyebilir.\nBunu çözmek için sayfada izin verilecek çevirisiz içerik yüzdesi için bir eşik belirleyebilirsiniz. Çevirisiz içerik bu eşiği aşarsa kullanıcılar otomatik olarak sayfanın orijinal dil sürümüne yönlendirilir.",
        "never": "Asla"
      },
      "translate_error_pages": {
        "title": "Hata sayfalarını çevir",
        "description": "Linguise tüm hata sayfalarını çevirebilir, ancak IP adresi veya istek kimliği gibi dinamik içerik içeriyorlarsa bu sayfaların çevirisinden kaçınmalısınız.",
        "not_found_page": {
          "title": "404 sayfasını çevir"
        },
        "error_page": {
          "title": "Diğer hata sayfalarını çevir"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Mevcut alan adı bulundu",
          "description": "Bu kullanıcı için mevcut bir alan adı bulundu, onu kullanmak ister misiniz?"
        }
      },
      "search_tl": {
        "title": "Çevirilerde Ara",
        "description": "Web sitenizin platformu için çeviri aramayı etkinleştirin (Deneyseldir, bu seçenek çeviri kullanımlarınızı artıracaktır)"
      },
      "shopify_promo": {
        "info": "İyi haber! Artık Shopify Uygulama Mağazası'ndan indirebileceğiniz yerel bir Shopify uygulamamız var.",
        "hyperlink": "Buraya tıklayın ve uygulama üzerinden Linguise kurulumunu gerçekleştirin.",
        "next_btn": "Uygulamayı yüklemek için Shopify mağazasına gidin.",
        "info_legacy": "İyi haber! Artık Shopify Uygulama Mağazası'ndan indirebileceğiniz yerel bir Shopify uygulamamız var.",
        "description_legacy": "\"Shopify Legacy\" yerine \"Shopify\" platformunu seçin."
      },
      "wix_promo": {
        "info": "İyi haber! Artık Wix Uygulama Pazarı'ndan indirebileceğiniz yerel bir Wix uygulamamız var.",
        "hyperlink": "Buraya tıklayın ve uygulama üzerinden Linguise kurulumunu gerçekleştirin.",
        "next_btn": "Uygulamayı yüklemek için Wix Uygulama Pazarı'na gidin.",
        "info_legacy": "İyi haber! Artık Wix Uygulama Pazarı'ndan indirebileceğiniz yerel bir Wix uygulamamız var.",
        "description_legacy": "\"Wix Legacy\" yerine \"Wix\" platformunu seçin."
      },
      "ai_disallow_deletion": "AI kotası hâlâ kullanılabilir durumdayken bu alanı silemezsiniz.\n\nBu alanı silmek istiyorsanız lütfen destek ekibimizle iletişime geçin.",
      "language_removal": {
        "card": {
          "title": "Kaldırılan dillerin çevirilerini sil",
          "description": "Bu diller web sitenizden kaldırıldı ancak kayıtlı çevirileri hâlâ kotanıza dahil. Kelimeleri geri almak için çevirileri silin.",
          "button": "Çevirileri sil"
        },
        "hint": "Kullanılan kelimeler kotanıza geri eklenir. Bunu her web sitesi için {{days}} günde bir yapabilirsiniz.",
        "modal": {
          "title": "Çeviriler silinsin mi?",
          "intro": "Bu çeviriler kalıcı olarak silinecek:",
          "warning": "Bu işlem geri alınamaz. Kullanılan kelimelerin kotanıza eklenmesi birkaç dakika sürebilir.",
          "limit": "Bunu her web sitesi için {{days}} günde bir yapabilirsiniz.",
          "confirm": "Çevirileri sil"
        },
        "scheduled": "Çeviriler siliniyor ve kotanız kısa süre içinde güncellenecek.",
        "cooldown": "Bu web sitesinin çevirileri yakın zamanda silindi. {{date}} tarihinde tekrar silebilirsiniz.",
        "latest_completed": {
          "title": "Son tamamlanan silme işlemi",
          "description": "Silinen dilleri ve kotanıza geri eklenen kelimeleri inceleyin.",
          "languages": "Silinen diller",
          "words_returned": "Kotaya geri eklenen kelimeler: {{words}}",
          "completed_at": "{{date}} tarihinde tamamlandı"
        },
        "status": {
          "recent_title": "Son çeviri silme işlemi",
          "recent_description": "Son silme işlemini izleyin ve bir sonrakinin ne zaman kullanılabilir olduğunu görün.",
          "progress_title": "Silme ilerlemesi",
          "loading": "Silme ilerlemesi kontrol ediliyor...",
          "unavailable": "Silme ilerlemesi yüklenemedi. Sayfayı yenileyip tekrar deneyin.",
          "label": "Durum",
          "pending": "Sırada",
          "processing": "Devam ediyor",
          "completed": "Tamamlandı",
          "failed": "Başarısız",
          "unknown": "Durum kullanılamıyor",
          "percent": "%{{percent}} tamamlandı",
          "current_stage": "Geçerli adım: {{stage}}",
          "processed": "{{processed}} kayıt işlendi",
          "processed_total": "{{total}} kaydın {{processed}} kadarı işlendi",
          "requested_at": "{{date}} tarihinde istendi",
          "started_at": "{{date}} tarihinde başlatıldı",
          "completed_at": "{{date}} tarihinde tamamlandı",
          "cooldown_period": "Bunu her web sitesi için {{days}} günde bir yapabilirsiniz.",
          "cooldown_blocked": "Henüz başka bir silme işlemi başlatılamaz.",
          "stage": {
            "queued": "Başlaması bekleniyor",
            "processing": "Devam ediyor",
            "refund_summary": "Geri verilen kelimeler hesaplanıyor",
            "search_translations": "Arama çevirileri siliniyor",
            "url_translations": "URL çevirileri siliniyor",
            "translations": "Çeviriler siliniyor",
            "completed": "Tamamlandı",
            "failed": "Başarısız",
            "unknown": "Devam ediyor"
          }
        },
        "forbidden": "Çevirileri silme izniniz yok."
      }
    },
    "main": {
      "edit": "Alan adını düzenle",
      "add": "Alan adı ekle",
      "wizard": "Hoş geldiniz! Yeni alan adı oluşturma sihirbazı",
      "common": "Alan adı"
    },
    "notice": {
      "broken_card": "{{url}} için mevcut ödeme yönteminizi kullanarak planınızı yenileyemedik, lütfen ödeme kartınızı güncelleyin",
      "quota_reached": "{{url}} için çeviri kotanız ulaşıldı, lütfen web sitenizin çevirisine devam etmek için yükseltme yapın",
      "ai_no_subscription": "{{url}} için yapay zekâ çevirisi etkin bir abonelik veya etkin deneme gerektirir. Olmadan duracaktır, devam etmek için lütfen yükseltin",
      "important": "Önemli",
      "quota_reached_button": "Planınızı hemen yükseltin",
      "broken_card_button": "Ödeme kartınızı güncelleyin",
      "ai_no_subscription_button": "Planınızı hemen yükseltin",
      "quota_warning": "{{url}} için çeviri kotanız {{throttling_used_percent}}%'e ulaştı, bu kota {{ttl}} dakika içinde sıfırlanacak.",
      "locked": "{{url}} alanı şu anda geçiş için kilitli, sitenize hâlâ erişebiliyorsunuz ancak yeni çevirileri düzenleyemiyor veya ekleyemiyorsunuz!"
    },
    "subdomains": {
      "config_ok": "Alt alan adı DNS&apos;i doğru şekilde yapılandırıldı.",
      "config_invalid": "Alt alan adı DNS&apos;sinin çalışması için bazı ek yapılandırmalar gerekiyor.",
      "config_check": "Alt alan adı DNS yapılandırması kontrol ediliyor, lütfen bekleyin...",
      "entri_timeout": "Entri, alt alan adı DNS yayını sürecinizin zaman aşımına uğradığını bildirdi; tekrar denemeniz veya manuel olarak yapmanız gerekecek.",
      "entri_process": "DNS kayıtlarınız Entri ile eklendi ve genellikle 10-30 dakika içinde yayılır (es.domain.com gibi tüm dil alt alan adlarınız uygulanır). DNS doğrulaması 24 saat sonra tamamlanmazsa destek ekibimize ulaşabilirsiniz: support@linguise.com",
      "entri_ok": "DNS yayını yolda! Yayınlanması bekleniyor...",
      "infos": "Çeviriyi etkinleştirmek için bu DNS kayıtlarını DNS alan adı kayıtlarınıza eklemeniz gerekir. İşlem tamamlandığında onay düğmesine tıklayın. DNS kayıtlarının yayılması biraz zaman alabilir, bu nedenle birkaç dakika veya saat sonra tekrar kontrol etmeniz gerekebilir.",
      "check": "DNS yapılandırmasını kontrol edin."
    },
    "subscription": {
      "next_payment_amount": "Yaklaşan ücretler",
      "next_payment_date": "Sonraki ödeme tarihi",
      "invoice": {
        "header": "Fatura geçmişi",
        "date": "Tarih",
        "amount_due": "Tutar",
        "status": "Durum",
        "actions": "İşlemler",
        "description": "İşlemler hazır olduğunda buradan görüntüleyebilirsiniz.",
        "status_text": {
          "draft": "Taslak",
          "failed": "Başarısız",
          "open": "Beklemede",
          "paid": "Ödendi",
          "retrying": "Yeniden deneniyor",
          "uncollectible": "Tahsil edilemez",
          "void": "Geçersiz"
        },
        "view": "Görüntüle",
        "empty": "Bu abonelik için son fatura bulunamadı",
        "retry_payment": "Yeniden dene"
      },
      "next_cancellation": "İptal tarihi",
      "cancel": "Aboneliği iptal et",
      "change_plan": "Planı değiştir",
      "change": "Değiştir",
      "suspend": "Ödemeyi askıya al",
      "resume": "Aboneliğe devam et",
      "back": "Geri",
      "save": "Kaydet",
      "confirm_resume": "Bu aboneliğe gerçekten devam etmek istiyor musunuz?",
      "confirm_cancel": "Bu aboneliği gerçekten iptal etmek istiyor musunuz?",
      "confirm_header": "Emin misiniz?",
      "missing_status": "Bu abonelik eksik",
      "not_found": "Bu alan adı için abonelik bulunamadı",
      "confirm_manual_retry": "Bu ödemeyi gerçekten yeniden denemek istiyor musunuz?",
      "no_payment_method": "Bilinmiyor",
      "remove_billing": "Kaldır",
      "shopify_maneged": "Bu abonelik Shopify tarafından yönetiliyor. Lütfen Shopify yönetici panelinizden yönetin.",
      "unknown_plan": "Bilinmeyen plan"
    }
  },
  "domain_listing": {
    "add": "Web sitesi ekle",
    "select": "Bir alan adı seç"
  },
  "editable": {
    "number": "sayı {{id}}"
  },
  "footer": {
    "about": "Hakkımızda",
    "support": "Destek"
  },
  "frontendEditor": {
    "main": "Canlı Editör",
    "description": "Canlı Editör, web sitenizdeki çevirileri doğrudan düzenlemenize yardımcı olur.",
    "button": "Canlı Editör&apos;ü aç",
    "language_selection": "Çeviri dili seçimi",
    "video_label": "Canlı editörü nasıl kullanacağınızı öğrenin"
  },
  "general": {
    "403": {
      "tab_title": "Hata - 403 Hatası",
      "title": "Erişim reddedildi",
      "message": "Görünüşe göre istenen sayfaya erişiminiz yok.",
      "home": "Ana Sayfaya Dön"
    },
    "404": {
      "tab_title": "Hata - 404 Hatası",
      "title": "Sayfa Bulunamadı",
      "message": "Sanırım yanlış bir yere gittiniz. Merak etmeyin... en iyilerimize de olur. İşte yeniden yolunuza dönmenize yardımcı olacak küçük bir ipucu.",
      "home": "Ana Sayfaya Dön"
    },
    "500": {
      "tab_title": "500 Hatası",
      "title": "Dahili Sunucu Hatası",
      "message": "Sayfanızı yenilemeyi deneyebilir misiniz? veya bize ulaşabilirsiniz",
      "home": "Ana Sayfaya Dön"
    },
    "fields": {
      "alert": "Bazı alanlar geçerli değil, lütfen geçersiz alanları düzeltin.",
      "invalid": "Bu alan geçersiz",
      "phone_re": "Telefon numarası geçersiz",
      "phone_invalid": "Telefon numarası geçersiz",
      "email": "E-posta alanı geçersiz."
    },
    "table": {
      "no_data": "Henüz burada veri yok..."
    },
    "saving": "Kaydediliyor ...",
    "save": "Kaydet",
    "save_and_quit": "Kaydet ve Çık",
    "invite": "Davet et",
    "cancel": "İptal",
    "yes": "Evet",
    "no": "Hayır",
    "nextStep": "Sonraki adım",
    "loading": "Uygulama yüklenirken lütfen bekleyin",
    "goback": "Geri dön",
    "manage": "Yönet",
    "delete": "Sil",
    "deleting": "Siliniyor ...",
    "confirm": "Onayla",
    "unknown": "Bilinmiyor",
    "hide": "Saklamak",
    "show": "Göstermek",
    "on": "Açık",
    "off": "Kapalı",
    "default": "Varsayılan"
  },
  "home": {
    "header": "Ana Sayfa",
    "manage": "Aboneliği yönet",
    "canceled": "İptal için planlandı",
    "activate_now": "Hemen etkinleştir",
    "activate_plan_now": "Hemen abone ol",
    "upgrade_plan_now": "Planı hemen yükselt",
    "trial_message_part_1": "Şu anda deneme planındasınız, ",
    "trial_message_part_2": "istediğiniz zaman üyelik başlatabilirsiniz.",
    "add": "Alan adı ekle",
    "table": {
      "title": "Alan Adları",
      "description": "Çevirileri yönetmek için alan adına tıklayın"
    },
    "domains": {
      "empty": "Bu hesapta herhangi bir alan adınız yok"
    },
    "accountsList": {
      "title": "Hesaplar",
      "add": "Yeni hesap ekle",
      "name": "Hesap adı"
    },
    "update_credit_card": "Kredi kartı bilgilerini güncelle",
    "cancelling_subs": "{{0}} tarihinde iptal ediliyor",
    "resume_subscription": "Aboneliği sürdür",
    "shopify_managed": "Shopify tarafından yönetiliyor",
    "trial_ends_at": "{{0}} tarihinde bitiyor",
    "free_trial": "Ücretsiz deneme",
    "no_subs": "Etkin abonelik yok"
  },
  "invoices": {
    "title": "Faturalar",
    "list": {
      "title": "Fatura listesi"
    },
    "table": {
      "customer": "Müşteri",
      "domain": "Alan adı",
      "amountPaid": "Ödenen tutar",
      "status": "Durum",
      "date": "Tarih",
      "invoice": "Fatura",
      "pay": "Fatura öde",
      "actions": "İşlemler",
      "deleted_domain": "Alan adı silindi",
      "plan_name": "Plan",
      "action": "İşlem"
    },
    "listPending": {
      "title": "Bekleyen faturalar listesi"
    }
  },
  "language_settings": {
    "display": "Dil listesi gösterimi",
    "position": "Konum",
    "display_help_text": "Bayrak ve/veya dil adlarını göster. Dil değiştirici varsayılan konumu içerikte herhangi bir yerde olabilir veya kaydırıldığında sabit kalan sabit bir konumda olabilir",
    "side_by_side": "Yan yana",
    "dropdown": "Açılır menü",
    "popup": "Açılır pencere",
    "flag": "Bayrak",
    "lang_name": "Dil adı",
    "lang_short_name": "Kısa adlar",
    "positions": {
      "in_place": "Yerinde",
      "top_left": "Sol üst",
      "top_left_no_scroll": "Sol üst (kaydırmaz)",
      "top_right": "Sağ üst",
      "top_right_no_scroll": "Sağ üst (kaydırmaz)",
      "bottom_left": "Sol alt",
      "bottom_left_no_scroll": "Sol alt (kaydırmaz)",
      "bottom_right": "Sağ alt",
      "bottom_right_no_scroll": "Sağ alt (kaydırmaz)"
    },
    "lang_names_display": {
      "title": "Dil adı görünümü",
      "help_text": "Dil değiştiricide dil adlarını İngilizce veya orijinal dilde göster, yani French veya Français",
      "english": "İngilizce",
      "native_languages": "Ana Diller"
    },
    "flag_shape": {
      "title": "Bayrak stili",
      "help_text": "Yuvarlak svg veya dikdörtgen svg bayrak simgeleri kullan",
      "round": "Yuvarlak",
      "rectangular": "Dikdörtgen"
    },
    "english_flag_type": {
      "title": "İngiliz bayrağı türü",
      "help_text": "İngilizce için Büyük Britanya veya ABD bayrağı kullan",
      "usa": "ABD bayrağı",
      "great_britain": "Büyük Britanya bayrağı"
    },
    "german_flag_type": {
      "title": "Alman bayrağı türü",
      "help_text": "Almanca için Avusturya veya Almanya bayrağı kullan",
      "german": "Almanya bayrağı",
      "austria": "Avusturya bayrağı"
    },
    "spain_flag_type": {
      "title": "İspanyol bayrağı türü",
      "help_text": "İspanyolca için Meksika veya İspanya bayrağı kullan",
      "spanish": "İspanya bayrağı",
      "mexico": "Meksika bayrağı",
      "peruvian": "Peru bayrağı"
    },
    "portugal_flag_type": {
      "title": "Portekiz bayrağı türü",
      "help_text": "Portekizce için Portekiz veya Brezilya bayrağı kullan",
      "portugal": "Portekiz bayrağı",
      "brazil": "Brezilya bayrağı"
    },
    "taiwanese_flag_type": {
      "title": "Tayvan bayrağı türü",
      "help_text": "Tayvan için Tayvan veya Çin bayrağı kullan",
      "taiwanese": "Tayvan bayrağı",
      "chinese": "Çin bayrağı"
    },
    "flag_border_radius": {
      "title": "Bayrak kenarlık yuvarlaklığı (px)",
      "help_text": "Dikdörtgen bayrak şekli kullanıyorsanız piksel cinsinden özel bir kenarlık yuvarlaklığı uygulayabilirsiniz"
    },
    "flag_width": {
      "title": "Bayrak boyutu (px)",
      "help_text": "Piksel cinsinden bayrak boyutunu seçin. .svg formatında olduğu için görüntü ağırlığını değiştirmez"
    },
    "lang_color": {
      "color_title": "Dil adı rengi",
      "color_help_text": "Dil adlarınız için varsayılan bir metin rengi seçin",
      "hover_color_title": "Dil adı hover rengi",
      "hover_color_help_text": "Dil adlarınız için fare üzerine gelme metin rengi seçin",
      "color_popup_title": "Açılır dil rengi",
      "color_popup_help_text": "Açılır pencere veya açılır menü alanlarındaki dil başlığının rengi",
      "hover_color_popup_title": "Açılır dil hover rengi",
      "hover_color_popup_help_text": "Açılır pencere veya açılır menü alanlarındaki dil başlığı için fare üzerine gelme metin rengi seçin"
    },
    "flag_box_shadow": {
      "shadow_title": "Bayrak gölgesi",
      "shadow_help_text": "Dil bayraklarınız için renk ve gölge boyutu",
      "hover_shadow_title": "Bayrak hover gölgesi",
      "hover_shadow_help_text": "Dil bayraklarınız için fare üzerine geldiğinizde renk ve gölge boyutu",
      "shadow_h_offset": "Gölge Y yatay (px)",
      "shadow_v_offset": "Gölge V dikey (px)",
      "shadow_blur": "Gölge bulanıklığı (px)",
      "shadow_spread": "Gölge yayılımı (px)",
      "shadow_color": "Gölge rengi"
    },
    "order": "Dil sırası",
    "language_order_help": "Dil değiştiricide gösterilecek dil sırası. Dilleri yeniden sıralamak için sürükleyip bırakabilirsiniz.",
    "order_reset": "Sıfırla sırası",
    "language_order_dragdrop": "Dilleri yeniden sıralamak için sürükleyip bırakabilirsiniz.",
    "popup_lang_name": "Açılır pencere dil adı",
    "preview": "Dil önizleme"
  },
  "link": {
    "form": {
      "original": {
        "title": "Orijinal Kaynak",
        "description": "Orijinal bağlantı URL'nizi ekleyin ve aşağıda dillerine çevirmek için değiştirin",
        "srcset_description": "Bir resim url'si düzenliyorsunuz. Srcset kullanıyorsanız veya bunun ne olduğunu bilmiyorsanız lütfen dokümantasyonu okuduğunuzdan emin olun",
        "link": "Bağlantı",
        "match_link": "Eşleştirme modu",
        "match_exact": "Tam",
        "match_wildcard": "Joker",
        "match_regex": "Düzenli ifade"
      },
      "alternative_languages": {
        "title": "Yerini alacak bağlantılar",
        "description": "Sayfalarınızdaki medya bağlantılarını ve harici bağlantıları dille yerine a e göre değiştirin…",
        "link": "Yerini alacak bağlantı"
      },
      "error": {
        "atLeastOne": "Lütfen en az bir çeviri ekleyin.",
        "url": "Adres geçersiz",
        "extension": "Bağlantıda bir uzantı olmalı, ancak .html veya .php olamaz. Ayrıca bağlantıda \"/fr\" gibi bir dil yolu içermemelidir.",
        "regex": "Regex geçersiz",
        "wildcard": "Joker karakterli bağlantının protokolü geçersiz"
      }
    },
    "main": {
      "parent": "Bağlantılar",
      "edit": "Bağlantıyı düzenle"
    }
  },
  "links": {
    "title": "Medya ve harici bağlantı yönetimi",
    "description": "Web sitenizdeki medya bağlantılarını veya harici bağlantıları listeleyin ve düzenleyin.",
    "add": "Bağlantı Ekle",
    "delete": "Bağlantıyı Sil",
    "table": {
      "original": "Orijinal",
      "language": "Dil",
      "translation": "Çeviri",
      "action": "İşlem",
      "delete_confirm": "Lütfen bağlantı silme işlemini onaylayın"
    }
  },
  "members": {
    "header": "Üyeler",
    "invite": "Yeni üye davet et",
    "modal": {
      "inviteHeader": "Yeni üye davet et",
      "editHeader": "Üyeyi düzenle",
      "detachHeader": "Üyeyi ayır",
      "detachBody": "Bu üyeyi hesaptan ayırmak istediğinize emin misiniz?",
      "selfDetachBody": "Bu hesap yönetiminden kendinizi ayırmak istediğinize emin misiniz? Bundan sonra bu hesaba ilişkin hiçbir veriye erişemezsiniz."
    },
    "table": {
      "title": "Üyeler listesi",
      "description": "Üye rolleri ve alan adı erişimleri",
      "name": "Ad",
      "email": "E-posta",
      "websites": "Web siteleri",
      "languages": "Diller",
      "role": "Rol",
      "status": "Durum",
      "resendInvite": "yeniden gönder",
      "inviteSent": "davet gönderildi",
      "actions": "İşlemler",
      "edit": "Düzenle",
      "detach": "Ayır",
      "empty": "Henüz üyeniz yok",
      "all_website": "Tüm web siteleri ve diller",
      "roles": {
        "admin": "Yönetici",
        "manager": "Müdür",
        "translator": "Çevirmen"
      },
      "statuses": {
        "pending": "Beklemede",
        "accepted": "Kabul edildi",
        "declined": "Reddedildi"
      }
    },
    "errors": {
      "role": "Bir rol seçmelisiniz",
      "domains": "Seçilen rol için en az 1 web sitesi seçmelisiniz",
      "languages": "Seçili web siteleri için en az 1 dil seçmelisiniz"
    },
    "inviteSent": "Davetiniz başarıyla gönderildi"
  },
  "pagination": {
    "showing": "{{limit}} / {{total}} sonuç gösteriliyor",
    "showing_only_count": "{{limit}} sonuç gösteriliyor"
  },
  "payments_method": {
    "header": "Ödeme Yöntemleri",
    "table": {
      "title": "Ödeme yöntemleri listesi",
      "description": "Hesabınıza bağlı ödeme yöntemleri",
      "default": "Varsayılan",
      "action_edit_remove": "Düzenle veya kaldır",
      "action_remove": "Kaldır",
      "action_default": "Varsayılan yap",
      "action_fallback": "Yedek yap",
      "expires": "Sona tarihi",
      "add_new_card": "Ödeme yöntemi ekle",
      "action_fallback_remove": "Yedekten kaldır",
      "fallback": "Yedek",
      "action_edit": "Düzenle",
      "action_delete": "Sil",
      "action_default_remove": "Varsayılanlıktan çıkar",
      "domain_count@@one": "{{count}} alan adı tarafından kullanılıyor",
      "domain_count@@other": "{{count}} alan adı tarafından kullanılıyor"
    },
    "paypal_bind": {
      "button": "PayPal Hesabını Bağla",
      "button_load": "Bağlanıyor...",
      "disconnected": "Bağlı değil",
      "success": "PayPal hesabınız şimdi bağlandı, bir sonraki faturanızdan 5 $ düşülecek!",
      "success_no_promo": "PayPal hesabınız şimdi bağlandı",
      "error": "Bir hata oluştu",
      "success_header": "Başarılı"
    },
    "card_add": {
      "header": "Yeni kart ekle",
      "success": "Yeni kart Linguise'ye bağlandı!",
      "terms": "Kart bilginizi sağlayarak, hizmet şartlarımıza göre Linguise'nin gelecekteki ödemeler için kartınızdan ücret almasına izin vermiş olursunuz."
    },
    "card_detail": {
      "header": "Kart bilgisi",
      "delete": {
        "error": "Bu ödeme yöntemini silemezsiniz çünkü üzerinde etkin abonelikler bulunuyor!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Bu ödeme yöntemindeki abonelikler",
        "header_domain": "Alan adı",
        "header_plan": "Plan",
        "header_status": "Durum",
        "header_actions": "İşlemler",
        "cancelling": "İptal tarihi: {{0}}",
        "next_payment": "Sonraki ödeme tarihi: {{0}}",
        "action_renew": "Yenile",
        "no_subs_header": "Gösterilecek abonelik yok",
        "no_subs_desc": "Bu karta bir abonelik yapıldığında tüm bilgiler burada görüntülenecektir",
        "action_manage": "Yönet"
      },
      "status": {
        "active": "Aktif",
        "canceled": "İptal edildi",
        "incomplete": "Ödenmemiş",
        "incomplete_expired": "Ödenmemiş (Süresi dolmuş)",
        "missing": "Hata",
        "past_due": "Vadesi geçmiş",
        "trialing": "Deneme",
        "unpaid": "Ödenmemiş"
      }
    },
    "delete_confirm_body": "Bu ödeme yöntemini silmek istediğinize emin misiniz? Bu işlem geri alınamaz!",
    "delete_confirm_header": "Ödeme yöntemi silinsin mi?",
    "card_edit": {
      "header": "Kartı düzenle",
      "billing_header": "Fatura bilgileri",
      "address_error": "Adres zorunludur!",
      "card_number": "Kart numarası",
      "card_expiry": "Son kullanma tarihi",
      "expiry_error_month": "Geçersiz ay girildi",
      "expiry_error_year": "Geçersiz yıl girildi",
      "expiry_error_expired": "Kartınızın son kullanma yılı geçmişte.",
      "card_header": "Kart bilgileri",
      "expiry_error_empty": "Bu alan zorunludur!"
    }
  },
  "plans": {
    "per": "başına",
    "wordsTranslated": "çevrilen kelime",
    "current": "Mevcut",
    "archived": "Arşivlenmiş",
    "day": "gün",
    "week": "hafta",
    "month": "ay",
    "year": "yıl",
    "activate": "Aktif et",
    "cancel": "İptal",
    "change": "Değiştir",
    "upgrade": "Yükselt",
    "downgrade": "Düşür",
    "resume": "Sürdür",
    "notEnoughWords": "Yeterli kelime yok",
    "yearIntervalOnly": "Yıllık plandan geçilemez",
    "subsCanceled": "Devam eden başka bir abonelik iptali var",
    "wordsUnlimited": "Sınırsız kelime",
    "tabs": {
      "day": "Günlük fiyatlar",
      "week": "Haftalık fiyatlar",
      "month": "Aylık fiyatlar",
      "year": "Yıllık fiyatlar",
      "sub_texts": {
        "day": "Sabit bir fiyat, her gün",
        "week": "Sabit bir fiyat, her hafta",
        "month": "Sabit bir fiyat, her ay",
        "year": "Bir ay ücretsiz, yılda bir fatura"
      }
    },
    "details": {
      "new_languages": "İstediğiniz zaman yeni dil ekleyin",
      "one_month_trial": "Her yeni web sitesine bir aylık ücretsiz deneme",
      "multi_content_indexed": "Çok dilli içeriğin %100’ü indekslenir",
      "translate_new_content": "Yeni içeriği anında çevir",
      "free_installation": "Ücretsiz kurulum ve ayar",
      "compared_monthly_plan": "Aylık planlara göre bir ay ücretsiz",
      "risk_free_recurring": "Risksiz tekrarlayan ödeme hatası",
      "unlimited_languages": "Sınırsız dil ve sayfa görüntüleme",
      "high_server_resources": "Yüksek sunucu kaynakları",
      "billed": {
        "day": "Günlük faturalandırılır",
        "week": "Haftalık faturalandırılır",
        "month": "Aylık faturalandırılır",
        "year": "Yıllık faturalandırılır"
      },
      "request_max_size": "{{0}} maksimum istek boyutu"
    },
    "frequent_question": {
      "title": "Sık sorulan sorular",
      "questions": {
        "trial": {
          "question": "Denemeyi yeni bir alan adında kullanabilir miyim?",
          "answer": "Evet, hesabınıza eklediğiniz her yeni web sitesi için 30 günlük ücretsiz deneme sunuyoruz. Bu sayede çeviri hizmetini sitenizde tam olarak test edebilirsiniz."
        },
        "seo": {
          "question": "SEO’mun gelişmesi ne kadar sürer?",
          "answer": "İçerik ve çok dilli içerik tamamen indekslenip iyi sıralanması için zaman gerekir. Web sitenizin trafiğine ve büyüklüğüne göre 3 ila 6 hafta arasında değişir."
        },
        "quota": {
          "question": "İnsan çevirileri kotaya dahil mi?",
          "answer": "Hayır, kelime sınırı yalnızca otomatik makine çevirileri içindir. Çevirmen otomatik çevirileri limitsiz olarak manuel olarak düzenleyebilir."
        }
      }
    },
    "best_offer": "En iyi teklif",
    "period": {
      "days@@one": "gün",
      "days@@other": "{{count}} gün",
      "hours@@one": "saat",
      "hours@@other": "{{count}} saat",
      "minutes@@one": "dakika",
      "minutes@@other": "{{count}} dakika",
      "seconds@@one": "saniye",
      "seconds@@other": "{{count}} saniye"
    },
    "words": {
      "billion": "{{value}} M",
      "million": "{{value}} M",
      "thousand": "{{value}} B"
    },
    "throttling_info": "{{words}} kelime / {{period}}"
  },
  "profile": {
    "welcome": "Hoş geldiniz!",
    "account": "Hesabım",
    "subscriptions": "Abonelikler",
    "logout": "Çıkış"
  },
  "register": {
    "errors": {
      "password": "En az 8 karakter, herhangi bir karakter"
    }
  },
  "route": {
    "dashboard": "Panel",
    "rules": "Kurallar",
    "translations": "Çeviriler",
    "search_translations": "Arama Sorguları",
    "urls_translations": "URL Çevirileri",
    "links": "Medya ve dış bağlantılar",
    "online_editor": "Canlı Editör",
    "settings": "Ayarlar",
    "domain": {
      "finish": "Ayarlar",
      "preconfig": "Ayarlar"
    },
    "home": "Ana Sayfa",
    "domain_list": "Alan adı listesi",
    "members": "Üyeler",
    "invoices": "Faturalar",
    "billing": "Fatura bilgileri",
    "language_display": "Dil bayrakları görünümü",
    "payment_methods": "Ödeme Yöntemleri",
    "ai_translation": "Yapay Zeka Çevirisi",
    "ai_translation_settings": "Ayarlar",
    "ai_translation_pricing": "Fiyatlandırma"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Göz ardı edilecek metin",
        "add": "Yeni ekle",
        "title": "Göz ardı edilecek metin",
        "description": "Bir veya birden fazla göz ardı edilecek metin ekleyin",
        "ignore_case": "Büyük/küçük harf duyarsız"
      },
      "html_content": {
        "title": "HTML içeriğe uygula",
        "description": "Kuralı tüm içeriğe ya da belirli bir CSS seçicisiyle uygula",
        "all_page": "Tüm sayfa",
        "css_selector": "CSS seçici",
        "label": "CSS seçici",
        "placeholder": "Uygulanacak seçici",
        "add": "Yeni ekle"
      },
      "apply_to_urls": {
        "title": "URL’lere uygula",
        "description": "Kuralların uygulanmasını istediğiniz belirli URL’leri seçin",
        "all_urls": "Tüm URL’ler",
        "selected_urls": "Seçili URL’ler",
        "label": "Uygulanacak URL",
        "placeholder": "Uygulanacak URL",
        "original_url": "Orijinal URL’ler",
        "translated_url": "Çevrilmiş URL",
        "wildcard": "Genel arama karakteri",
        "regex": "Düzenli ifade",
        "add": "Yeni ekle",
        "expression": "İfade türü"
      },
      "apply_urls": {
        "title_exclude": "URL’lerde hariç tut",
        "title_replace": "URL’lerde değiştir",
        "title_description": "Bu kuralı URL’lerin çevirisine de uygula"
      },
      "apply_languages": {
        "title": "Dillere uygula",
        "description": "Kuralların uygulanmasını istediğiniz belirli dili seçin",
        "all_languages": "Tüm diller",
        "selected_languages": "Seçili diller",
        "placeholder": "Dil seçin...",
        "feedback": "Bir dil seçmelisiniz"
      },
      "name": {
        "title": "Başlık",
        "description": "Kolaylık olması için kuralınıza bir başlık verin",
        "placeholder": "Kural adı"
      },
      "type": {
        "title": "Tür",
        "description": "Eklemek istediğiniz kural türünü seçin",
        "text_ignore": "Metin yoksay",
        "text_replace": "Metin değiştir",
        "content_exclusion": "İçerik hariç tutma",
        "url_exclusion": "URL ile hariç tutma",
        "ignore_inline": "Satır içi yoksay",
        "full_description": {
          "text_ignore": "Çevrilmesini istemediğiniz bazı metinler için kurallar ekleyin. Ürün adınız, marka adınız veya çevrilmesini istemediğiniz diğer teknik öğeler olabilir.",
          "text_replace": "Metin değiştirme, bazı metinleri istediğiniz çeviriyle değiştirmenize olanak tanır; çeviri bağlamı göz ardı edildiğinde gerekebilir.",
          "content_exclusion": "İçerik hariç tutma, sayfadaki bazı içeriklerin çevrilmesini engellemenize yardımcı olur.\n Bir sayfayı tamamen çeviriden hariç tutmak istiyorsanız (bu sayfa için hiç çok dilli URL olmaması ve çevrilmiş içerik bulunmaması) lütfen \"URL ile hariç tutma\" türünü kullanın",
          "url_exclusion": "Sayfa çevirisi hariç tutma, çevirmek istemediğiniz sayfaları ayarlamanıza yardımcı olur.",
          "ignore_inline": "Bazı içeriklerin satır içi çevrilmesini engelleyin, bunun yerine her etiketi ayrı ayrı çevirin."
        }
      },
      "text_replace": {
        "title": "Değiştirilecek metin",
        "description": "Bazı metinleri kendi belirlediğiniz çeviriyle değiştirin. Sayfalarınızın her yerinde, dile göre...",
        "text_to_replace": "Değiştirilecek metin",
        "ignore_case": "Büyük/küçük harf yoksay",
        "text_type": "Çeviride değiştirme",
        "text_type_original": "Orijinal",
        "text_type_translation": "Çeviri",
        "keep_case": "Büyük/küçük harfi korumaya çalış",
        "add": "Yeni ekle"
      },
      "content_exclusion": {
        "title": "İçerik hariç tutma",
        "description": "Çevrilmeyecek bir veya daha fazla CSS seçicisi seçin",
        "label": "CSS seçicisi",
        "placeholder": "Uygulanacak seçici",
        "add": "Yeni ekle"
      },
      "multilingual_url": {
        "title": "Çok dilli URL kullan",
        "description": "Evet olarak ayarlanırsa URL çevrilmez ancak sayfa çevrilmiş içerikle çok dilli kalır",
        "live_example_title": "Canlı örnek",
        "live_example_description": "Kaynak URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Oluşturulan URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Oluşturulan URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Kuralı statik içerikte, dinamik içerikte ya da her ikisinde de uygulayın",
        "title": "İçeriğe uygula",
        "all": "Tüm içerik",
        "static": "Statik içerik",
        "dynamic": "Dinamik içerik"
      },
      "force_apply_urls": {
        "title_description": "Bu kuralı tüm URL çevirilerine, mevcut çeviriler dahil, zorla uygula!",
        "title_replace": "URL’lerde zorla değiştir",
        "title_exclude": "URL’lerde zorla hariç tut",
        "warning": "Uyarı",
        "warning_part1": "Bunu \"Evet\" yapmak web sitenizin URL çevirilerini bozabilir.",
        "warning_part2": "Bu geçici ya da kalıcı olarak 404 hatası oluşturabilir; lütfen sonuçlarını anlıyorsanız devam edin.",
        "warning_replacement_original": "Ek uyarı: URL’yi etkileyebilecek orijinal içerik değiştirmeye çalışıyorsunuz; Linguise orijinal URL’leri doğru şekilde bulamadığı için çeviri başarısız olabilir."
      }
    },
    "main": {
      "parent": "Kurallar",
      "edit": "Kuralı düzenle",
      "add": "Yeni kural"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" içerikte ve URL’de yoksayılacak",
      "preview_single": "\"{{text_ignore}}\" içerikte yoksayılacak",
      "preview_more_with_url": "\"{{text_ignore}}\" ve {{count}} tane daha içerikte yoksayılacak",
      "preview_more": "\"{{text_ignore}}\" ve {{count}} tane daha içerikte yoksayılacak",
      "other_parameters": "Bu kural için başka parametreler ayarlandı, daha fazla bilgi için düzenle düğmesine tıklayın"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" içerikte ve URL’lerde \"{{replacement}}\" ile değiştiriliyor",
      "preview_single": "\"{{original}}\" içerikte \"{{replacement}}\" ile değiştiriliyor",
      "preview_more_with_url": "\"{{original}}\" içerikte ve URL’lerde \"{{replacement}}\" ile değiştiriliyor ve {{nb}} tane daha",
      "preview_more": "\"{{original}}\" içerikte \"{{replacement}}\" ile değiştiriliyor ve {{nb}} tane daha",
      "other_parameters": "Bu kural için başka parametreler ayarlandı, daha fazla bilgi için düzenle düğmesine tıklayın"
    },
    "content_exclusion": {
      "selectors": "Çeviriden {{nb}} CSS seçicisi hariç tutuldu",
      "other_parameters": "Bu kural için başka parametreler ayarlandı, daha fazla bilgi için düzenle düğmesine tıklayın"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL çeviriden hariç tutuldu ancak çok dilli önek korundu",
      "some": "{{nb}} URL tamamen çeviriden hariç tutuldu",
      "all_multilingual": "tüm URL’ler çeviriden hariç tutuldu ancak çok dilli önek korundu",
      "all": "tüm URL’ler tamamen çeviriden hariç tutuldu",
      "other_parameters": "Bu kural için başka parametreler ayarlandı, daha fazla bilgi için düzenle düğmesine tıklayın"
    },
    "ignore_inline": {
      "elements": "Sayfadaki tüm satır içi içerik blok içerik olarak çevrilecek",
      "all_elements": "Sayfadaki bazı satır içi içerik blok içerik olarak çevrilecek",
      "other_parameters": "Bu kural için başka parametreler de ayarlanmıştır, daha fazla bilgi edinmek için düzenle düğmesine tıklayın."
    },
    "title": "Kural yönetimi",
    "description": "Web sitenizin genelinde çeviri içerik hariç tutmalarını ve değiştirmelerini yönetin",
    "add": "Yeni kural ekle",
    "table": {
      "title": "Başlık",
      "no_data": "Henüz kural yok",
      "type": "Tür",
      "preview": "Kural önizlemesi",
      "action": "İşlem",
      "delete_confirm": "Kural silmeyi onaylayın",
      "types": {
        "text_ignore": "Metin yoksay",
        "text_replace": "Metin değiştir",
        "content_exclusion": "İçerik dışlama",
        "url_exclusion": "URL dışlama",
        "ignore_inline": "Satır içi yoksay",
        "unknown": "Bilinmeyen kural"
      }
    },
    "apply_on_content": {
      "static": "Bu kural yalnızca statik içeriklere uygulanacaktır.",
      "dynamic": "Bu kural yalnızca dinamik içeriklere uygulanacaktır."
    }
  },
  "search_translations": {
    "title": "Arama sorguları yönetimi",
    "description": "Arama formları aracılığıyla kullanılan tüm web sitesi çevirilerinizi listeler (çevrilen dilden alan adınızın temel diline)",
    "filter_languages": "Dillere göre filtrele...",
    "filter_original": "Orijinal dilde metni filtrele",
    "filter_translation": "Çevrilmiş metne göre filtrele",
    "table": {
      "original": "Orijinal",
      "language": "Dil",
      "translation": "Çeviri"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Abone olunamadı!",
      "title": "Abone olunamadı!",
      "subtitle": "Aboneliğiniz işlenirken bir hata oluştu.",
      "home": "Ana sayfaya dön",
      "generic": "Linguise tarafında bilinmeyen bir hata oluştu, lütfen yöneticiye başvurun!"
    },
    "success": {
      "home": "Alan adı çevirilerini yönet",
      "message": "Size en iyi çeviri deneyimini sunmaya kararlıyız. Uzmanlarımızdan oluşan ekibimiz, ihtiyaç duyabileceğiniz her türlü soru ve destek konusunda size yardımcı olmaya hazırdır. Başlamak için aşağıdaki düğmeye tıklamanız yeterlidir.",
      "subtitle": "Linguise çeviri hizmetini seçtiğiniz için teşekkür ederiz",
      "title": "Abonelik etkinleştirildi!",
      "tab_title": "Abonelik için teşekkürler!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Abonelik etkinleştirildi!",
      "title": "Abonelik etkinleştirildi!",
      "subtitle": "Linguise çeviri hizmetini seçtiğiniz için teşekkür ederiz",
      "message": "Size en iyi çeviri deneyimini sunmaya kararlıyız. Uzmanlarımızdan oluşan ekibimiz, ihtiyaç duyabileceğiniz her türlü soru ve destek konusunda size yardımcı olmaya hazırdır. Başlamak için aşağıdaki düğmeye tıklamanız yeterlidir.",
      "home": "Alan adı çevirilerini yönet"
    },
    "edit": {
      "title": "Aboneliği yönet"
    },
    "list": {
      "title": "Abonelik listesi",
      "description": "Alan adı aboneliklerinizin listesi"
    },
    "table": {
      "domain": "Alan adı",
      "plan": "Paket",
      "status": "Durum",
      "card": "Kart",
      "usage": "Kullanım",
      "actions": "İşlemler",
      "payment_method": "Ödeme Yöntemi"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} kelime",
      "paidOffered": "{{words_used}} / {{words_allowed}} kelime\n({{free_words}} ücretsiz kelime dahil)"
    },
    "popup": {
      "dueToday": "Bugün vadesi dolacak toplam",
      "nextPeriod": "{{date}} tarihinden itibaren"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Bir hesap seçin"
    }
  },
  "translation": {
    "main": {
      "parent": "Çeviriler",
      "edit": "Çeviriyi düzenle"
    },
    "form": {
      "original": {
        "title": "{{language}} dilinde orijinal"
      },
      "is_inline": "Bu çeviri satır içi içerikten yapılmıştır.",
      "inline_editor": {
        "count_warning": "Satır içi alanların sayısı orijinaliyle eşleşmiyor ({{current}} / {{expected}}).",
        "restore_original": "Orijinal metni geri yükle",
        "insert_placeholder": "Yer tutucu ekle",
        "drag": "Alanı yeniden sıralamak için sürükle",
        "area": "Satır içi alan {{index}}",
        "restore": "Eksik satır içi alanları geri yükle"
      },
      "translation": {
        "title": "{{language}} dilinde çeviri",
        "description": "Geçersiz kılmak istediğiniz çeviri"
      }
    },
    "copy": {
      "title": "Manuel çeviriye kopyala",
      "label": "Manuele kopyala"
    },
    "level": {
      "base": {
        "title": "Temel çeviri",
        "subtitle": "Otomatik · Linguise Cloud çevirisi",
        "empty": "Bu metin için temel çeviri yok.",
        "overridden": "Seçiminiz kaydedildi, ancak Yapay Zeka Çevirisi ayarlarında “Manuel ve seçili çevirilerin üzerine yaz” Evet olduğu için bunun yerine en yeni yapay zeka ile geliştirilmiş çeviri gösteriliyor. Seçiminizi kullanmak için bu ayarı kapatın."
      },
      "not_generated": "Oluşturulmadı",
      "none": "Henüz yok",
      "ai": {
        "title": "Yapay zeka ile geliştirilmiş çeviri",
        "subtitle": "Otomatik · Linguise AI",
        "empty_title": "Bu metin için henüz oluşturulmadı",
        "empty_description": "Linguise AI, sayfanızın ve sitenizin bağlamını kullanarak daha doğal çeviriler üretir. Burada bir çeviri görmek için:",
        "empty_step_1": "Yapay Zeka Çevirisi › Ayarlar bölümüne gidin ve Yapay zeka çevirisini aç ayarını “Yalnızca kurallar”, “Yalnızca canlı düzenleyici” veya “Kurallar ve canlı düzenleyici” olarak belirleyin.",
        "empty_step_2": "Bu sayfayla eşleşen bir kuralla uygulayın veya Canlı Editör'den sayfa sayfa etkinleştirin.",
        "empty_step_3": "Yapay zeka ile geliştirilmiş çeviri, oluşturulduğunda burada görünür. Yapay zeka kredilerinizi kullanır.",
        "open_settings": "Yapay Zeka Çevirisi ayarlarını aç",
        "open_editor": "Canlı Editör'ü aç",
        "overrides_selection": "Seçiminiz kaydedildi, ancak Yapay Zeka Çevirisi ayarlarında “Manuel ve seçili çevirilerin üzerine yaz” Evet olduğu için bunun yerine bu yapay zeka ile geliştirilmiş çeviri gösteriliyor. Seçiminizi kullanmak için bu ayarı kapatın.",
        "overrides_version": "Seçtiğiniz sürüm kaydedildi, ancak Yapay Zeka Çevirisi ayarlarında “Manuel ve seçili çevirilerin üzerine yaz” Evet olduğu için bunun yerine en yeni yapay zeka ile geliştirilmiş sürüm gösteriliyor. Seçtiğiniz sürümü kullanmak için bu ayarı kapatın."
      },
      "manual": {
        "title": "Manuel çeviri",
        "subtitle": "Sizin yazdığınız · otomatik çevirilere göre önceliklidir",
        "empty": "Boş",
        "saved_but_overridden": "Seçiminiz olarak kaydedildi, ancak Yapay Zeka Çevirisi ayarlarında “Manuel çevirilerin üzerine yaz” Evet olduğu için otomatik gösterilmiyor: bu ayar kapatılana kadar yapay zeka ile geliştirilmiş çeviri geçerlidir.",
        "ignored": "Yapay Zeka Çevirisi ayarlarında “Manuel çevirilerin üzerine yaz” Evet olduğu için otomatik gösterilmiyor. Bu metin için kullanmak üzere seçin.",
        "label": "Çeviriniz",
        "placeholder": "Kendi çevirinizi yazın...",
        "last_updated": "Son düzenleme {{date}}",
        "save_hint": "Manuel çeviriyi kaydetmek onu etkin yapar.",
        "delete": "Manuel çeviriyi sil",
        "delete_confirm": "Lütfen manuel çevirinin silinmesini onaylayın"
      }
    },
    "history": {
      "title": "Yapay zeka ile geliştirilmiş sürümler",
      "subtitle": "Canlı Editör'den yapılan her yeniden oluşturma saklanır",
      "unknown_model": "Bilinmeyen model",
      "current": "Mevcut",
      "restore": "Bu sürümü geri yükle",
      "restore_note": "Geri yükleme, o sürümü mevcut yapay zeka ile geliştirilmiş çeviri yapar. Hiçbir şey silinmez.",
      "version_of": "Sürüm {{current}} / {{total}}",
      "hide": "Geçmişi gizle ({{total}})",
      "show": "Geçmişi göster ({{total}})"
    },
    "choose": {
      "title": "{{language}} çevirileri · ziyaretçilerin göreceğini seçin",
      "current": "Şu anda sitenizde:",
      "priority": "Varsayılan öncelik: Manuel › Yapay zeka ile geliştirilmiş › Temel. Seçiminiz yalnızca bu çeviri için kaydedilir.",
      "reset": "Varsayılan önceliğe sıfırla",
      "reset_title": "Bu metin için seçiminizi unutun ve varsayılan önceliği yeniden kullanın",
      "resetting": "Sıfırlanıyor ..."
    }
  },
  "translations": {
    "title": "Çeviriler yönetimi",
    "description": "Tüm web sitesi çevirilerinizi listeler ve düzenlersiniz; görsel çeviri için Canlı Düzenleyiciyi kullanın",
    "filter_languages": "Dillere göre filtrele...",
    "filter_original": "Orijinal dilde metni filtrele",
    "filter_translation": "Çevrilmiş metne göre filtrele",
    "table": {
      "original": "Orijinal",
      "language": "Dil",
      "action": "İşlem",
      "base": "Temel",
      "ai": "YZ geliştirmeli",
      "manual": "Manuel"
    },
    "filter_exact": "Tam eşleşme",
    "badge": {
      "active": "Etkin",
      "overrides_manual": "Manueli geçersiz kılar"
    },
    "cell": {
      "none": "yok",
      "not_generated": "oluşturulmadı",
      "ignored": "Yok sayıldı – YZ kuralı geçerli"
    },
    "tabs": {
      "all": "Tümü",
      "manual": "Manuel olan",
      "ai": "YZ geliştirmeli olan",
      "base": "Yalnızca temel"
    },
    "levels_hint": "Her metnin en fazla 3 düzeyi vardır — Etkin olarak işaretlenen, ziyaretçilerin gördüğüdür."
  },
  "url": {
    "main": {
      "parent": "URL’ler",
      "edit": "URL çevirisini düzenle"
    },
    "form": {
      "original": {
        "title": "{{language}} dilinde orijinal"
      },
      "translation": {
        "title": "{{language}} dilinde URL çevirisi",
        "description": "Geçersiz kılmak istediğiniz URL",
        "placeholder": "URL çevirisi geçersiz kılma",
        "invalid_full": "Yanlış biçimde değişiklik yapmaya çalışıyorsunuz; yalnızca URL çevirisinin slugs/pathname bölümünü değiştirmelisiniz",
        "invalid": "Geçersiz URL/yol sağlandı"
      }
    }
  },
  "urls": {
    "title": "URL’ler yönetimi",
    "description": "Tüm web sitesi URL’lerinizin çevrilmiş içeriklerini listeler ve düzenlersiniz (gelişmiş, 404 hatalarına dikkat)",
    "filter_languages": "Dillere göre filtrele...",
    "filter_original": "Orijinal dilde metni filtrele",
    "filter_translation": "Çevrilmiş metne göre filtrele",
    "table": {
      "original": "Orijinal",
      "language": "Dil",
      "url": "Çevrilmiş URL",
      "action": "İşlem",
      "edited": "Orijinal çeviri düzenlendi"
    }
  }
}
